import {
    TRAFFIC_SOURCE,
} from '../enums';

const normalizeTrafficSource = (rawSource: string): TRAFFIC_SOURCE | null => {
    const source = rawSource.trim().toLowerCase();
    switch (source) {
    case 'direct':
        return TRAFFIC_SOURCE.direct;
    case 'referral':
    case 'referral-other':
    case 'referral_other':
        return TRAFFIC_SOURCE.referralOther;
    case 'x':
    case 'twitter':
    case 'x-twitter':
    case 'xtwitter':
        return TRAFFIC_SOURCE.xTwitter;
    case 'twitch':
        return TRAFFIC_SOURCE.twitch;
    case 'tiktok':
    case 'tik-tok':
        return TRAFFIC_SOURCE.tiktok;
    case 'youtube':
    case 'yt':
        return TRAFFIC_SOURCE.youtube;
    case 'linkedin':
        return TRAFFIC_SOURCE.linkedin;
    case 'facebook':
    case 'fb':
        return TRAFFIC_SOURCE.facebook;
    case 'instagram':
    case 'ig':
        return TRAFFIC_SOURCE.instagram;
    case 'substack':
        return TRAFFIC_SOURCE.substack;
    case 'email':
    case 'e-mail':
    case 'mail':
        return TRAFFIC_SOURCE.email;
    case 'chapter-email':
        return TRAFFIC_SOURCE.chapterEmail;
    case 'reddit':
    case 'rdt':
        return TRAFFIC_SOURCE.reddit;
    case 'discord':
        return TRAFFIC_SOURCE.discord;
    case 'threads':
    case 'threads.net':
        return TRAFFIC_SOURCE.threads;
    case 'bluesky':
    case 'bsky':
    case 'bsky.app':
        return TRAFFIC_SOURCE.bluesky;
    case 'github':
    case 'gh':
        return TRAFFIC_SOURCE.github;
    case 'chatgpt':
    case 'openai':
        return TRAFFIC_SOURCE.chatgpt;
    case 'perplexity':
        return TRAFFIC_SOURCE.perplexity;
    case 'claude':
    case 'anthropic':
        return TRAFFIC_SOURCE.claude;
    case 'google':
        return TRAFFIC_SOURCE.google;
    case 'bing':
        return TRAFFIC_SOURCE.bing;
    case 'duckduckgo':
    case 'ddg':
        return TRAFFIC_SOURCE.duckduckgo;
    case 'yahoo':
        return TRAFFIC_SOURCE.yahoo;
    case 'whatsapp':
    case 'wa':
        return TRAFFIC_SOURCE.whatsapp;
    case 'telegram':
    case 'tg':
        return TRAFFIC_SOURCE.telegram;
    case 'signal':
        return TRAFFIC_SOURCE.signal;
    default:
        return null;
    }
};

export default normalizeTrafficSource;
